import axios from 'axios';
import ClaimRequestReferralTable, {
  tableColumns
} from 'components/tables/ClaimRequestReferralTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { errorHandler } from 'helpers/response-utils';

const ClaimReferralList = () => {
  const [rewardClaims, setRewardClaims] = useState([]);
  const token = localStorage.getItem('token');
  const [statusFilter, setStatusFilter] = useState('pending');
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    getList();
  }, [statusFilter, pagination]);

  const getList = async () => {
    const url = `/reward-claim-request`;

    const params: Record<string, any> = {
      pointType: 'referral',
      status: statusFilter,
      page: pagination.pageIndex + 1,
      pageSize: pagination.pageSize
    };

    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}${url}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: params
      }
    );

    errorHandler(response);

    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }

    setRewardClaims(response.data['data']['rewardClaims']);
    setTotalRecords(response.data['data']['totalRecords']);
  };

  const handleSubmit = async (id: number, status: string) => {
    const data = { id, status };
    const response = await axios.put(
      `${process.env.REACT_APP_ENDPOINT}/reward-claim-request/referral`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }

    toast.success(response.data['message']);
    return true;
  };

  const handlePaginationChange = (updater: any) => {
    const newState =
      typeof updater === 'function' ? updater(pagination) : updater;
    setPagination(newState);
  };

  const table = useAdvanceTable({
    data: rewardClaims,
    columns: tableColumns,
    pageSize: pagination.pageSize,
    pagination: true,
    sortable: true,
    selection: true,
    initialState: {
      columnVisibility: {}
    },
    meta: {
      handleSubmit: handleSubmit,
      manualPagination: true,
      totalRecords: totalRecords,
      onPaginationChange: handlePaginationChange,
      pagination: pagination,
      getList: getList
    }
  });

  return (
    <div>
      <div className="mb-6">
        <AdvanceTableProvider {...table}>
          <Row className="g-3 justify-content-between mb-4">
            <Col xs="auto">
              <h2 className="mb-0"> {totalRecords} Pending Request</h2>
            </Col>
            <Col xs="auto"></Col>
          </Row>
          <ClaimRequestReferralTable />
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default ClaimReferralList;
